(() => {
  function mount(root) {
    if (root.dataset.edMounted) return;
    root.dataset.edMounted = 'true';
 const previewMetal = event => {
  const link = event.target.closest('.signature-r1-metals .swatch__link');
  if (link) link.closest('.signature-r1-metals').setAttribute('data-preview-metal', link.dataset.metal);
 };
 const restoreMetal = event => {
  const row = event.target.closest('.signature-r1-metals');
  if (!row) return;
  const next = event.relatedTarget instanceof Element ? event.relatedTarget.closest('.swatch__link') : null;
  if (next && row.contains(next)) row.setAttribute('data-preview-metal', next.dataset.metal);
  else row.removeAttribute('data-preview-metal');
 };
 root.addEventListener('pointerover', previewMetal);
 root.addEventListener('focusin', previewMetal);
 root.addEventListener('pointerout', restoreMetal);
 root.addEventListener('focusout', restoreMetal);
 root.addEventListener('click', event => {
  const link = event.target.closest('.signature-r1-metals .swatch__link');
  if (!link) return;
  link.closest('.signature-r1-metals').querySelectorAll('.swatch__link').forEach(item => {
   if (item === link) item.setAttribute('aria-current', 'true');
   else item.removeAttribute('aria-current');
  });
 });
    root.querySelectorAll('[data-sig-rail]').forEach(rail => {
      const controls = rail.nextElementSibling;
      if (!controls?.matches('[data-sig-controls]')) return;
      const slides = Array.from(rail.children), prev = controls.querySelector('[data-sig-prev]'), next = controls.querySelector('[data-sig-next]'), position = controls.querySelector('[data-sig-position]');
      let scheduled = false;
      const update = () => {
        scheduled = false;
        const bounds = rail.getBoundingClientRect();
        const visible = slides.map((slide, index) => ({index, bounds: slide.getBoundingClientRect()})).filter(s => s.bounds.right > bounds.left + 2 && s.bounds.left < bounds.right - 2);
        const first = (visible[0]?.index ?? 0) + 1, last = (visible.at(-1)?.index ?? 0) + 1;
        position.textContent = first === last ? `${first} / ${slides.length}` : `${first}–${last} / ${slides.length}`;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        controls.hidden = rail.scrollWidth <= rail.clientWidth + 2;
      };
      const move = direction => {
        const step = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : rail.clientWidth;
        rail.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      rail.addEventListener('keydown', event => { if(event.target === rail && ['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);} });
      rail.addEventListener('scroll', () => {if(!scheduled){scheduled=true;requestAnimationFrame(update);}}, {passive:true});
      new ResizeObserver(update).observe(rail); update();
    });
    root.querySelectorAll('.sig-filters a,.ed-pagination a').forEach(a => { const url = new URL(a.href); url.searchParams.set('view', root.dataset.edView); const preview = new URL(location.href).searchParams.get('preview_theme_id'); if (preview) url.searchParams.set('preview_theme_id', preview); a.href = url.href; });
  }
  document.querySelectorAll('[data-ed-catalogue]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ed-catalogue]').forEach(mount));
})();
